import { render } from "./AddPrimaryStorage.vue?vue&type=template&id=02fe973c&scoped=true"
import script from "./AddPrimaryStorage.vue?vue&type=script&lang=js"
export * from "./AddPrimaryStorage.vue?vue&type=script&lang=js"

import "./AddPrimaryStorage.vue?vue&type=style&index=0&id=02fe973c&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.3.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fe973c"]])

export default __exports__